export const MATCH_SETTINGS_GROUP = 'self-match';
